/**
 * Rinet sender constants
 */

export let Constants = {
  DATE_TIME_FMT: 'dd.MM.yyyy HH:mm',
  DATE_FMT: 'dd.MM.yyyy',
  BS_DATE_FMT: 'DD.MM.YYYY'
};
